var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandLogoMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 19,
    viewBox: "0 0 32 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_579_4777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9744 0L11.2524 11.341L16.0396 17.9974L20.7476 11.4529L15.9744 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7322 12.1427L25.7396 5.37915L16.3657 18.4122L16.375 18.4262L28.7322 12.1427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9907 18.6453H32.0002V11.01L16.9907 18.6453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34668 12.1427L6.33925 5.37915L15.7132 18.4122L15.6992 18.4262L3.34668 12.1427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0095 18.6453H0V11.01L15.0095 18.6453Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_579_4777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 18.6453,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogoMini);
export default __webpack_public_path__ + "static/media/brand-logo-mini.9cb4f63e729c32695910a8df7e7c35ee.svg";
export { ForwardRef as ReactComponent };